// UploadDropzone.tsx
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";

interface UploadDropzoneProps {
	onFilesAccepted: (files: File[]) => void;
}

export function UploadDropzone({ onFilesAccepted }: UploadDropzoneProps) {
	const { t } = useTranslation();
	// A callback that fires when files are dropped or selected.
	const onDrop = useCallback(
		(acceptedFiles: File[]) => {
			onFilesAccepted(acceptedFiles);
		},
		[onFilesAccepted]
	);

	// Pass the callback and accepted file types to useDropzone
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
		multiple: true, // It´s here you choose what type of files you want to accept!!
	});

	return (
		<div
			{...getRootProps()}
			className={
				"flex flex-col items-center justify-center w-full border-2 border-dashed " +
				"border-gray-300 dark:border-gray-700 dark:bg-black dark:hover:bg-zinc-950 p-6 h-[200px] rounded-md text-center cursor-pointer hover:bg-gray-50 transition-colors"
			}
		>
			<input {...getInputProps()} />
			{isDragActive ? (
				<p className="text-gray-700 dark:text-gray-300 text-sm">
					{t("admin.dialog.upload-documents.doc-dnd-active")}
				</p>
			) : (
				<p className="text-gray-700 dark:text-gray-300 text-sm">
					{t("admin.dialog.upload-documents.doc-dnd")}
				</p>
			)}
		</div>
	);
}
